import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: '/login', // Mengarahkan ke halaman login
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      // {
      //   path: '/dashboard',
      //   name: 'dashboard',
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
      // },
      // {
      //   path: '/icons',
      //   name: 'icons',
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
      // },
      {
        path: '/profile',
        name: 'PROFIL PENGGUNA',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile.vue')
      },
      // {
      //   path: '/maps',
      //   name: 'maps',
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/GoogleMaps.vue')
      // },
      // {
      //   path: '/tables',
      //   name: 'tables',
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/RegularTables.vue')
      // },
      {
        path: '/user',
        name: 'PENGURUSAN PENGGUNA',
        component: () => import(/* webpackChunkName: "demo" */ '../views/senarai_user.vue')
      },
      {
        path: '/user/view/:id',
        name: 'Paparan Pengguna',
        component: () => import(/* webpackChunkName: "demo" */ '../views/view_user.vue')
      },
      {
        path: '/user/edit/:id',
        name: 'Kemaskini Pengguna',
        component: () => import(/* webpackChunkName: "demo" */ '../views/edit_user.vue')
      },
      // {
      //   path: '/agensi',
      //   name: 'agensi',
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/senarai_agensi.vue')
      // },
      {
        path: '/senarai-projek',
        name: 'Pengurusan Inisiatif',
        component: () => import(/* webpackChunkName: "demo" */ '../views/senarai_projek.vue')
      },
      {
        path: '/projek/view/:id',
        name: 'papar inisiatif',
        component: () => import(/* webpackChunkName: "demo" */ '../views/papar_projek.vue')
      },
      {
        path: '/projek/edit/:id',
        name: 'edit Inisiatif',
        component: () => import(/* webpackChunkName: "demo" */ '../views/edit_projek.vue')
      },
      {
        path: '/projek/add',
        name: 'tambah inisiatif',
        component: () => import(/* webpackChunkName: "demo" */ '../views/tambah_projek.vue')
      },
      {
        path: '/user/tukar/:id',
        name: 'Kemaskini Pentadbir',
        component: () => import(/* webpackChunkName: "demo" */ '../views/tukar_projek_owner.vue')
      },
      {
        path: '/reference',
        name: 'RUJUKAN',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Reference/Reference.vue')
      },
    ]
  },
  { path: '*', component: NotFound } // Menangani rute yang tidak ditemukan
];

export default routes;
